// import $ from 'jquery';
// import { createAlert } from 'dom/window';
// import _ from 'lodash';
// import { defaultAsyncPost } from '../actions/defaultActions';
import { axiosInstance as axios, handleAxiosErrors, checkEmptyOnList } from '_utils'
import config from '../store/_config'
import {
  convertPromotionDetailsToReact,
  convertBonusPromotionDetailsToReact,
  convertElasticProductsToReactSelect,
  convertPromotionListToReact,
} from '../selectors/converterSelectors'
import { buildPromotionData } from '../selectors/requestSelectors'
import moment from 'moment'
import { convertProductsListingToAReadableFormat } from '../selectors/productSelectors'
import $ from 'jquery'
// import { toggleCartLoading } from './cartActions';
import { createAlert } from '../dom/window'
import { axiosRequestProductList } from './productsSupplierActions'

export const toggleLoading = (key, value) => {
  return {
    type: 'TOGGLE_PROMOTION_LOADING',
    key: key,
    value: value,
  }
}

export const setPromotionList = (value) => {
  return {
    type: 'SET_PROMOTION_LIST',
    value: value,
  }
}

export const updatePromotionDetails = (key, value) => {
  return {
    type: 'UPDATE_PROMOTION_DETAILS',
    key: key,
    value: value,
  }
}

export const updateAvailableProducts = (value) => {
  return {
    type: 'UPDATE_PROMOTION_AVAILABLE_PRODUCTS',
    value: value,
  }
}

/**
 * Function to post promotion details data
 * Usually used for promotion editor form
 *
 * @param params
 */
export const postPromotionDetails = () => {
  return (dispatch, getState) => {
    const state = getState()

    let postData = buildPromotionData(state.promotionsSupplier.details)

    dispatch(toggleLoading('form', true))

    return axiosCreatePromotion(postData)
      .then((response) => {
        if (response.data.data.createSupplierPromotion) {
          window.location.href = '/supplier/promotions/'
        } else {
          createAlert({}, 'error')
        }

        // if (status) {
        //     if (url) {
        //         window.location.href = url;
        //     }
        //
        //     if (message) {
        //         createAlert(response.data, 'success');
        //     }
        // }
        // else {
        //     createAlert(response.data, 'error');
        // }
      })
      .catch((error) => {
        handleAxiosErrors(error)
      })
      .then(() => {
        dispatch(toggleLoading('form', false))
      })
  }
}

/**
 * Function to request promotion list
 *
 * @param params
 */
export const requestPromotionList = () => {
  return (dispatch, getState) => {
    let { url, query } = config.supplierPromotion.list

    dispatch(toggleLoading('list', true))

    return axios
      .get(url, {
        params: {
          query: query,
        },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.data.readSupplierPromotions.edges) {
          const list = convertPromotionListToReact(
            response.data.data.readSupplierPromotions.edges,
            constructEmptyData()
          )

          dispatch({
            type: 'SET_PROMOTION_LIST',
            value: list,
          })
        } else {
          console.log('Invalid response')
        }
      })
      .catch((error) => {
        handleAxiosErrors(error)
      })
      .then(() => {
        dispatch(toggleLoading('list', false))
      })
  }
}

/**
 * Function to request promotion details data
 * Usually used for promotion editor form
 *
 * @param params
 */
export const requestPromotionDetails = (id) => {
  return (dispatch, getState) => {
    if (!id) {
      dispatch(toggleLoading('detail', false))
      return
    }

    let { url, query } = config.supplierPromotion.details
    query = query.replace('{id}', id)

    dispatch(toggleLoading('detail', true))

    return axios
      .get(url, {
        params: {
          query: query,
        },
        withCredentials: true,
      })
      .then((response) => {
        if (typeof response.data.data.readOneSupplierPromotion != 'undefined') {
          const promotionDetails = convertPromotionDetailsToReact(
            response.data.data.readOneSupplierPromotion,
            constructEmptyData()
          )

          dispatch({
            type: 'SET_PROMOTION_DETAILS',
            value: promotionDetails,
          })

          // if(promotionDetails.discountType == 'Bonus') {
          //     dispatch(requestBonusPromotionDetails(id));
          // }
          // else {
          //     dispatch(toggleLoading('detail', false));
          // }
        } else {
          console.log('Invalid response')
        }
      })
      .catch((error) => {
        handleAxiosErrors(error)
      })
      .then(() => {
        dispatch(toggleLoading('detail', false))
      })
  }
}

/**
 * Function to request promotion details for bonus
 * Usually used for promotion editor form
 *
 * @param params
 */
export const requestBonusPromotionDetails = (id) => {
  return (dispatch, getState) => {
    if (id) {
      let { url, query } = config.supplierPromotion.bonusPromotionDetails
      query = query.replace('{id}', id)

      dispatch(toggleLoading('detail', true))

      return axios
        .get(url, {
          params: {
            query: query,
          },
          withCredentials: true,
        })
        .then((response) => {
          if (typeof response.data.data != 'undefined') {
            const state = getState()
            const promotionDetails = convertBonusPromotionDetailsToReact(
              response.data.data,
              state.promotionsSupplier.details
            )

            dispatch({
              type: 'SET_PROMOTION_DETAILS',
              value: promotionDetails,
            })
          } else {
            console.log('Invalid response')
          }

          dispatch(toggleLoading('detail', false))
        })
        .catch((error) => handleAxiosErrors(error))
    }
  }
}

export const constructEmptyData = () => {
  return {
    id: 0,
    title: '',
    LimitPerCustomer: '',
    description: '',
    discountType: '',
    durationFrom: moment().format('DD/MM/YYYY'),
    durationTo: moment().add(1, 'month').format('DD/MM/YYYY'),
    applyPromotionTo: '',
    BuyProducts: [],
    GetProducts: [],
    BuyQty: 0,
    GetQty: 0,
    QuantityDependentOffValue: '0.00',
    QuantityDependentOffPercentage: '0.00',
    buyQuantity: 0,
    getQuantity: 0,
    buyProducts: [],
    getProducts: [],
    buyProduct: 0,
    assignedCustomers: [],
    enabled: 1,
    caseDiscountType: '',
    caseDiscountValue: '',
    canChangeCaseDiscountType: 1,
    items: [],
  }
}

export const requestProductsDropdown = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const params = {
      startingIndex: 0,
      amount: 5000,
    }

    return axiosRequestProductList(state, params).then((response) => {
      const products = convertElasticProductsToReactSelect(
        convertProductsListingToAReadableFormat(response.data.data.searchResult.edges, state.user)
      )

      dispatch(updateAvailableProducts(products))
    })
  }
}

export const validatePromotionForm = (data) => {
  const { canChangeDiscountType, discountType } = data

  let validationStatus
  let standardRequiredFields = ['title', 'durationFrom', 'durationTo', 'assignedCustomers']

  // Standard Required Fields
  validationStatus = checkEmptyOnList(data, standardRequiredFields)

  if (validationStatus && canChangeDiscountType) {
    if (!discountType) {
      validationStatus = false
    }
  }

  if (validationStatus) {
    if (discountType == 'Bonus') {
      // Check: Discount Type Bonus
      let requiredFields = ['buyProducts', 'getProducts', 'buyQuantity', 'getQuantity']

      validationStatus = checkEmptyOnList(data, requiredFields)

      if (data.buyQuantity <= 0 || data.getQuantity <= 0) {
        validationStatus = false
      }
    } else if (discountType == 'Case Discount') {
      // Check: Discount Type Case Discount
      let requiredFields = ['buyProduct', 'caseDiscountType', 'caseDiscountValue']

      validationStatus = checkEmptyOnList(data, requiredFields)
    }
  }

  return validationStatus
}

/**
 * Axios to create promotion
 *
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const axiosCreatePromotion = (params) => {
  let { url, query } = config.supplierPromotion.create

  return axios.post(
    url,
    {
      query: query,
      variables: params,
    },
    {
      // withCredentials: true
    }
  )
}
